import { render, staticRenderFns } from "./LcaDisposal.vue?vue&type=template&id=430b9394"
import script from "./LcaDisposal.vue?vue&type=script&lang=js"
export * from "./LcaDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports